import { UntypedFormArray, UntypedFormControl, UntypedFormGroup } from "@angular/forms";

import { EntitetStatus } from "@dffedb/util";

import { NoteBilag } from "../model/note.model";

export class NoteBilagFormBuilder {
    public static bilagToFormArray(bilag: NoteBilag[]): UntypedFormArray {
        return new UntypedFormArray(bilag.map((b) => this.bilagToFormGroup(b)));
    }

    public static bilagToFormGroup(bilag: NoteBilag): UntypedFormGroup {
        const result = new UntypedFormGroup({
            filNavn: new UntypedFormControl(bilag.filNavn),
            filStoerrelseKb: new UntypedFormControl(bilag.filStoerrelseKb),
            noteBilagId: new UntypedFormControl(bilag.noteBilagId),
            status: new UntypedFormControl(bilag.status),
            url: new UntypedFormControl(bilag.url)
        });

        // Opdater status, hvis der sker ændringer på bilaget.
        this.updateStatus(result);
        result.valueChanges.subscribe(() => this.updateStatus(result));

        return result;
    }

    public static formArrayToBilag(array: UntypedFormArray): NoteBilag[] {
        return array.controls.map((c) => this.formGroupToBilag(c as UntypedFormGroup));
    }

    public static formGroupToBilag(group: UntypedFormGroup): NoteBilag {
        const result: NoteBilag = {
            filNavn: group.controls["filNavn"].value,
            filStoerrelseKb: group.controls["filStoerrelseKb"].value,
            noteBilagId: group.controls["noteBilagId"].value,
            status: group.controls["status"].value,
            url: group.controls["url"].value
        };
        return result;
    }

    private static updateStatus(formGroup: UntypedFormGroup): void {
        const status = formGroup.get("status");
        if (formGroup.dirty && status.value === EntitetStatus.Uaendret) {
            status.setValue(EntitetStatus.Aendret);
        }
        if (status.value !== EntitetStatus.Uaendret) {
            status.markAsDirty();
        }
    }
}
